const styles = {
  root: { width: 301, height: 72 }
};

export default styles;
